export const TEMPLATE_FILE_URL = {
  APPROVAL: "spreadsheet-template/edh-protocol-attribute-request-approval.xlsx",
  REVIEW: "spreadsheet-template/edh-protocol-attribute-review.xlsx",
};

export const PAGE_MODE = {
  REQUEST_APPROVAL: "request-approval",
  REVIEW: "review",
};

export const REQUEST_CD_TYPES = {
  REVIEW_ACTION_TYPE: "review_action_type",
  IN_DEF_COMMON_FLAG_TYPE: "in_def_common_flag_type",
};

export const requestCdTypes = Object.values(REQUEST_CD_TYPES);
